module.exports = __webpack_public_path__ + "img/card-5.7d707ef6.jpeg";